import { inject, injectable } from 'inversify';
import Debug from 'debug';
import { CommandQueue } from '../shared/command-queue';
import { QuerySectionStatesCommand } from './query-section-states-command';

const debug = Debug('section-state-service');

export const SectionStateServiceSymbol = Symbol.for('SectionStateServiceSymbol');

@injectable()
export class SectionStateService {

  private remoteQueue: CommandQueue;

  constructor(
    @inject(QuerySectionStatesCommand)
    private querySectionStatesCommand: QuerySectionStatesCommand) {

    this.remoteQueue = new CommandQueue('section-state-remote');
  }

  public start() {
    debug('starting SectionStateService...');

    this.remoteQueue.start();
    this.remoteQueue.queue('query-section-states', () => this.querySectionStatesCommand.execute());
  }

  public async finish() {
    debug('stopping SectionStateService...');

    await this.remoteQueue.stop();

    debug('SectionStateService stopped...');
  }
}
